export const Texts = {
    OTHER: "Other",
    ENTER_TIP_AMOUNT: "Enter Tip Amount",
};

export const TIP_ITEM_HEIGHT = 36;
export const TIP_ITEM_WIDTH = 72;
export const TIP_ITEM_WIDTH_V4 = 76;
export const TIP_ITEM_VISIBILITY_THRESHOLD = 1;
